/**
 * Top-100 most-common-password blacklist (lower-cased). Anything matching here
 * is rejected outright regardless of class/length rules.
 */
const COMMON_PASSWORDS = new Set([
  'password', 'password1', 'password!', 'password1!', 'passw0rd', 'passw0rd!',
  'p@ssw0rd', 'p@ssword', 'p@ssword1', 'qwerty', 'qwerty123', 'qwerty1!',
  '123456', '12345678', '123456789', '1234567890', 'iloveyou', 'iloveyou1',
  'admin', 'admin123', 'admin1!', 'welcome', 'welcome1', 'welcome1!',
  'letmein', 'letmein1', 'letmein!', 'monkey', 'monkey123', 'monkey1!',
  'dragon', 'dragon123', 'football', 'football1', 'baseball', 'baseball1',
  'sunshine', 'princess', 'master', 'master1', 'shadow', 'abc123',
  'abcd1234', 'changeme', 'changeme1', 'changeme!', 'trustno1', 'starwars',
]);

/**
 * Password validation matching backend rules (8-50 chars, lowercase, digit, special).
 */
export function validatePassword(password: string): string[] {
  const errors: string[] = [];
  if (password !== password.trim()) {
    errors.push('Cannot start or end with whitespace');
  }
  if (COMMON_PASSWORDS.has(password.toLowerCase())) {
    errors.push('Password is too common — choose something more unique');
  }
  if (password.length < 8 || password.length > 50) {
    errors.push('Must be 8-50 characters');
  }
  if (!/[a-z]/.test(password)) {
    errors.push('Must contain a lowercase letter');
  }
  if (!/[0-9]/.test(password)) {
    errors.push('Must contain a number');
  }
  if (!/[#$^+=!*()@%&]/.test(password)) {
    errors.push('Must contain a special character (#$^+=!*()@%&)');
  }
  if (/(.)\1{3,}/.test(password)) {
    errors.push('Cannot have 4+ repeated characters');
  }
  // Check for 4+ sequential characters
  for (let i = 0; i < password.length - 3; i++) {
    const c1 = password.charCodeAt(i);
    const c2 = password.charCodeAt(i + 1);
    const c3 = password.charCodeAt(i + 2);
    const c4 = password.charCodeAt(i + 3);
    if ((c2 - c1 === 1 && c3 - c2 === 1 && c4 - c3 === 1) ||
        (c1 - c2 === 1 && c2 - c3 === 1 && c3 - c4 === 1)) {
      errors.push('Cannot have 4+ sequential characters');
      break;
    }
  }
  return errors;
}
